<template>
  <v-dialog v-model="value"
            width="500"
            persistent
            content-class="modal modal-round"
            @input="setFocus">

    <div class="close"
         @click="hideModal">&times;</div>

    <!-- <button slot="activator"
            @click="reset()">
      {{$t('message.spots.message.newGroup')}}
    </button> -->

    <v-card :key="form.id">
      <div class="form-body">
        <h1 class="text-muted text-center">
            {{$t('message.spots.message.accessPointGroup')}}
        </h1>
        <v-text-field ref="firstInput"
                      :label="$t('message.generics.message.name')"
                      name="Nome"
                      v-validate="'required'"
                      :error-messages="errors.collect($t('message.generics.message.name'))"
                      v-model="form.name"></v-text-field>
      </div>

      <div class="card-footer">
        <button class="btn btn-primary btn-round"
                @click="validate()">
          {{ isEdit ? this.$t('message.generics.message.edit') : this.$t('message.spots.message.create')}}
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
    import EventBus from '@packages/event-bus/index'

    export default {
        components: {

        },

        data() {
            return {
                show: false,
                form : {},
                isEdit: false,
                drag: false
            }
        },
      
        props: {
            node: {
                type: Object
            },
            value: {
                type: Boolean,
                default: false
            }
        },

        computed: {
        },

        methods: {
            dragToTrue() {
                this.drag = true
            },
            dragToFalse() {
                 this.drag = false
            },            
            closeModalClickOutside(event) {
                if(event.target.className.includes("v-overlay") && !this.drag) {
                     this.show = false       
                    this.hideModal()
                }
            },
            emitInput(val) {
                this.$emit("input", val);
            },
            hideModal() {
                this.emitInput(false);
            },
            setFocus() {
                if(this.value) {
                    this.$nextTick(() => {
                        this.$refs.firstInput.focus();
                    })
                }
            },
            async edit(id) {
                const accessPointGroup = await this.$api.accessPointGroup.get({
                    id
                })

                this.form = {
                    id: accessPointGroup.id,
                    name: accessPointGroup.nome,
                    localId: accessPointGroup.localId,
                }
                
                this.isEdit = true;
            },
            reset(){
                this.form = {
                    name: '',
                }
            },
            async validate() {
                const isValid = await this.$validator.validateAll();

                if(isValid) {
                    this.save();
                }

            },
            async save() {
                EventBus.$emit('SHOW_SPINNER')

                try {
                    if(!this.isEdit) {
                        const data = {
                            nome: this.form.name
                        }

                        if(this.node.tipo === 'LOCAL') {
                            const local = await this.$api.locals.get(this.node.id);

                            data.localId = local.id
                        } else if(this.node.tipo === 'GRUPO_PONTO_ACESSO') {
                            const accessPointGoup = await this.$api.accessPointGroup.get({id: this.node.id});
                            data.parentId = accessPointGoup.id
                            data.localId = accessPointGoup.localId
                        }


                        const newAccessPointGroup = await this.$api.accessPointGroup.create(data);

                        EventBus.$emit('show-message', {
                            type: 'SUCCESS',
                            message: this.$t('message.successMessages.message.accessPointGroupCreated'),
                            timeout: 2000
                        });

                        this.$emit('created', {...newAccessPointGroup, tipo: 'GRUPO_PONTO_ACESSO'});
                        
                        this.hideModal()
                    } else {
                        const data = {
                            id: this.form.id,
                            nome: this.form.name,
                            localId: this.form.localId
                        }

                        const updatedAccessPoint = await this.$api.accessPointGroup.update(data);

                        EventBus.$emit('UPDATE_NODE', {...updatedAccessPoint, tipo: 'GRUPO_PONTO_ACESSO'});

                        this.hideModal()
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    EventBus.$emit('CANCEL_SPINNER')

                }
            },

        },

        mounted() {
            this.reset()
            document.addEventListener('mousedown', this.dragToFalse);      
            document.addEventListener('mousemove', this.dragToTrue);            
            document.addEventListener('mouseup', this.closeModalClickOutside);
        },

        beforeDestroy() {
            document.removeEventListener('mousedown', this.dragToFalse);      
            document.removeEventListener('mousemove', this.dragToTrue);            
            document.removeEventListener('mouseup', this.closeModalClickOutside);
        }

    }
</script>

<style lang="scss" scoped>
.form-body {
  padding: 18px 50px 10px;
}

.btn {
  margin-right: 10px;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 160px;
}
</style>
